<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(String(item.value)) || values.includes(Number(item.value)) || item.value === value">
        <span
          v-if="item.raw.listClass == 'default' || item.raw.listClass == ''"
          :index="index"
          :class="item.raw.cssClass"
        >
          {{ item.label }}
        </span>
        <a-badge
          v-else
          :index="index"
          :status="$filters.statusFilter(item.raw.listClass)"
          :class="item.raw.cssClass"
          :text="item.label"
        >
        </a-badge>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DictTag',
  props: {
    options: {
      type: Array,
      default: null,
    },
    value: {
      type: [Number, String, Array],
      default: null,
    },
  },
  computed: {
    values() {
      if (this.value !== null && typeof this.value !== 'undefined') {
        if (Array.isArray(this.value)) {
          return this.value.map(v => String(v))
        } else {
          // 同时包含字符串和数字形式，确保能匹配
          const strValue = String(this.value)
          const numValue = Number(this.value)
          const values = [strValue]
          if (!isNaN(numValue) && strValue !== String(numValue)) {
            values.push(String(numValue))
          }
          return values
        }
      } else {
        return []
      }
    },
  },
  methods: {
    statusFilter_filter(lclass) {
      let str = ''
      lclass == 'primary' || lclass == 'info'
        ? (str = 'processing')
        : lclass == 'danger'
        ? (str = 'error')
        : (str = lclass)
      return str
    },
  },
  emits: ['update:value'],
}
</script>
